import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { Toggle } from '@fluentui/react/lib/Toggle';
import { useBoolean } from '@fluentui/react-hooks';
import DialogTemplate from './DialogTemplate';
import { FontWeights, ITextStyles, Icon, Text } from '@fluentui/react';

const textBoldStyle = { fontWeight: FontWeights.semibold };
const boldStyle: Partial<ITextStyles> = {
  root: textBoldStyle,
};

// const modalPropsStyles = { main: { minWidth: 900 } };

interface IMismatchVersionDialog {
  showDialog: boolean;
  onCancel: () => void;
}

const MismatchVersionDialog = (props: IMismatchVersionDialog) => {
  return (
    <DialogTemplate
      showDialog={props.showDialog}
      toggleShowDialog={() => props.onCancel()}
      title={'Error de verificación de versión'}
      onAccept={() => window.location.reload()}
      onCancel={() => props.onCancel()}
      acceptText={'Refrescar'}
      cancelText={'Volver al formulario'}
      hideCancelButton={false}
      minWidth={640}
    >
      <div className="text-center">
        <Text variant="xLarge" styles={boldStyle} block={true} style={{ marginTop: '20px' }}>
          Otro usuario ha cambiado este formulario mientras lo editabas.
        </Text>
        <Text variant="large" block={true}>
          Te recomendamos refrescar el formulario para que veas los ultimos cambios que se realizaron
        </Text>

        <Icon
          iconName="DisableUpdates"
          style={{ fontSize: 50, marginTop: 10 }}
          className={'text-icon-for-dialog'}
        />
      </div>
    </DialogTemplate>
  );
};

export default MismatchVersionDialog;
